import { Badge } from "@via/components/badge";
import { BadgeStatus } from "@via/utils/constants";
import { WorkbenchInstanceState, vmStateForUI } from "common";

export const getWorkbenchInstanceStatusLabel = (
  value: WorkbenchInstanceState
): JSX.Element => {
  switch (value) {
    case WorkbenchInstanceState.Provisioning:
    case WorkbenchInstanceState.Staging:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.WaitingFillColor}
          textColor={BadgeStatus.WaitingTextColor}
        />
      );
    case WorkbenchInstanceState.Running:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.RunningFillColor}
          textColor={BadgeStatus.RunningTextColor}
        />
      );
    case WorkbenchInstanceState.PendingStop:
    case WorkbenchInstanceState.Stopping:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.WaitingFillColor}
          textColor={BadgeStatus.WaitingTextColor}
        />
      );
    case WorkbenchInstanceState.Repairing:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.SuccessFillColor}
          textColor={BadgeStatus.SuccessTextColor}
        />
      );
    case WorkbenchInstanceState.Suspended:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.DefaultFillColor}
          textColor={BadgeStatus.DefaultTextColor}
        />
      );
    case WorkbenchInstanceState.Terminating:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.WaitingFillColor}
          textColor={BadgeStatus.WaitingTextColor}
        />
      );
    case WorkbenchInstanceState.Terminated:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.DefaultFillColor}
          textColor={BadgeStatus.DefaultTextColor}
        />
      );
    case WorkbenchInstanceState.Deleted:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.ErrorFillColor}
          textColor={BadgeStatus.ErrorTextColor}
        />
      );
    case WorkbenchInstanceState.Failed:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.ErrorFillColor}
          textColor={BadgeStatus.ErrorTextColor}
        />
      );
    case WorkbenchInstanceState.Resuming:
      return (
        <Badge
          text={vmStateForUI(value)}
          fillColor={BadgeStatus.WaitingFillColor}
          textColor={BadgeStatus.WaitingTextColor}
        />
      );
    default:
      return (
        <Badge
          text={value}
          fillColor={BadgeStatus.DefaultFillColor}
          textColor={BadgeStatus.DefaultTextColor}
        />
      );
  }
};
